module.exports = __webpack_public_path__ + "img/almouj-logo.3aa9eca9.png";